import { render } from "./T2Table.vue?vue&type=template&id=44bb038a"
import script from "./T2Table.vue?vue&type=script&lang=js"
export * from "./T2Table.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jenna\\Desktop\\Project\\Outsource\\jy-admin2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__